import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";

class ErrorComponent extends PolymerElement {

    static get template() {
        return html
            `
        <style>
            .content{
                display: inline-flex;
                font-size: 16px;
                width: 100%;
                align-items: center;
                border-left: 4px solid #DA2128;
                height: 48px;
            }
            .back-color {
                width: 4.25px;   
                height: 100%;
                background: #DA2128;
            }
            .icon-color {
                color: #BA293A;
                margin-left: 20px;
                margin-right: 4px;
            }
            .centre {
                display: flex;
                align-items: center;
            }
            .pos{
                position: absolute;
                right: 1%;
            }
            .width {
                width: 100%;
                box-shadow: 0px 2px 1px rgb(0 0 0 / 5%), 0px 0px 1px rgb(0 0 0 / 25%);
                background: #FFFFFF;
            }
            .weight{
                font-weight: bold;
            }
            .error-message {
                font-weight: 700;
                font-family: SF Pro Display;
                font-style: normal;
                font-size: 16px;
                line-height: 24px;
                color: #000000;
            }
            @media (max-width:479px)  {
                .content {
                    margin-left: 0px;
                    font-size: 16px;
                    width: 100%;
                    line-height: 20px;
                    display: flex;
                }
                .icon-color {
                    margin-right: 0px;
                    margin-left: 6px;
                }
            }
            ul {
                margin-block-start: 0em;
            }
            .close{
                padding-right: 25px;
                color: #BA293A;
                margin-left: auto;
                cursor: pointer;
            }
        </style>
        <div class="error-container">
            <template is="dom-if" if="{{isShowComponent}}">
                <div class="width error">
                    <div class="content">
                        <div class="centre">
                            <iron-icon class="icon-color" icon="error-outline"></iron-icon>
                        </div>
                        <div style="margin-left: 4px;">
                            <span class="error-message">{{errorMsg}}</span>
                        </div>
                        <div class="close">
                            <iron-icon on-tap="_hideErrorMessage" icon="close"></iron-icon>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        `
    }

    static get properties() {
        return {
            errorMsg: {
                type: String,
                value: '',
                notify: true
            },
            isShowComponent: {
                type: Boolean,
                value: false,
                notify: true
            },
            showCloseIcon: {
                type: Boolean,
                value: true,
                notify: true
            },
            closeClicked: {
                type: Boolean,
                value: false,
                notify: true
            }
        };
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('call-error', this._handleErrorEventListener.bind(this));
    }

    _handleErrorEventListener(e) {
        var errorMsg = (e && e.detail) ? e.detail : 'Something went wrong!';
        this.set('isShowComponent', true);
        this.set('errorMsg', errorMsg);
        document.getElementById('maincontent').scrollIntoView();
        if (!this.closeClicked) {
            this._disapperErrorAutomatically();
        }
    }

    _disapperErrorAutomatically() {
        var self = this;
        setTimeout(function () {
            self.set('isShowComponent', false);
        }, 1000 * 60)
    }

    _hideErrorMessage() {
        this.set('closeClicked', true);
        this.set('isShowComponent', false);
    }

}

customElements.define('error-component', ErrorComponent);